
<template>
	<div>
		<h6 class="ml-2"><strong>API Details</strong></h6>
		<form @submit.prevent="postIntegrationSettings" class="mb-3">
		<div class="row p-3">
			<div class="col-3">
				<div class="form-group input-content ">
					<label>Company Code</label>
						<div class="input-content">
							<input :class="{ 'not-allowed' : org_integration.company_code != '' }" :disabled="org_integration.company_code != ''"  v-model="editable_org_integration.company_code" type="text"/>
						</div>
				</div>
				<div class="form-group input-content ">
					<label>Division Code</label>
						<div class="input-content">
							<input :class="{ 'not-allowed' : org_integration.division_code != '' }" :disabled="org_integration.division_code != ''"  v-model="editable_org_integration.division_code" type="text"/>
						</div>
				</div>
			</div>
			<div class="col-3">
				<div class="form-group input-content ">
					<label>User</label>
						<div class="input-content">
							<input :class="{ 'not-allowed' : org_integration.user_info != '' }"  :disabled="org_integration.user_info != ''" v-model="editable_org_integration.user_info" type="text"/>
						</div>
				</div>
				<div class="form-group input-content ">
					<label>Password</label>
						<div class="input-content">
							<input :class="{ 'not-allowed' : org_integration.pass_code_secure != '' }" :disabled="org_integration.pass_code_secure != ''" v-model="editable_org_integration.pass_code_secure" type="text"/>
						</div>
				</div>
			</div>
			<div class="col-3">
				<label>Active Integration</label>
				<div class="input-content">
					<date-picker placeholder="Active integration date" class="date_picker_new" v-model="editable_org_integration.active_int_date" 
							:range="false" 
							:format="'MM-DD-YYYY'"
							:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
							:valueType="'YYYY-MM-DD'">
					</date-picker>
				</div>
			</div>
		</div>
		<button type="submit" class="button large-button integration-button">Save</button>
		</form>

	</div>
</template>
<script>
export default {
	props:{
		integration_id: Number
	},
	computed : {
		current_agency(){
			return this.$route.params.agency_id
		}
	},
	data : function(){
		return{
			org_integration:{
				company_code:'',
				division_code:'',
				pass_code_secure:'',
				user_info:'',
				active_int_date:'' 
			},
			editable_org_integration:{
				company_code:'',
				division_code:'',
				pass_code_secure:'',
				user_info:'',
				active_int_date:'' 
			},
			temp_org_integration: {}
	
		}
	},
	created : function(){
		this.getIntegrationSettings()

	},
	methods : {
		getIntegrationSettings(){ 
			var params = {
				id: this.current_agency,
				integration_id: this.integration_id,
			}
			this.$store.dispatch('getOrganizationIntegrationSettings', params).then((res) => {
				if(res.data.length == 0){
					//this.org_integration = {}
				}else{
				//	this.org_integration = res.data
					this.assignKeyValues(res.data, this.editable_org_integration)
					this.assignKeyValues(res.data, this.org_integration)
					// this.editable_org_integration = res.data
				}
			
			}).catch((error) => {
					console.log(error);
			});
		},
		async postIntegrationSettings(){ 
			this.temp_org_integration = this.removeEmptyKeyValues(this.editable_org_integration)
		
			var params = {
				id: this.current_agency,
				integration_id: this.integration_id,
				filters: this.temp_org_integration
			}
			this.$store.dispatch('UpdateOrganizationIntegrationSettings', params).then((res) => {
				this.temp_org_integration = {}
				this.getIntegrationSettings()
			}).catch((error) => {
					console.log(error);
			});
		},
		removeEmptyKeyValues: function(obj){
			var new_obj = {}
			  for (var propName in obj) {
				if ( obj[propName] != '') {
					new_obj[propName] = obj[propName]
				}
			}
			return new_obj
		},
		assignKeyValues: function(obj, obj_to_assign){
			for (var propName in obj) {
				if ( obj[propName] != '') {
					obj_to_assign[propName] = obj[propName]
				}
			}
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/integration/ViventiumIntegration.vue